import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Sanitiza o HTML gerado pelo Quill removendo atributos vazios e tags perigosas
 * como <style> e <script>, que se processadas pelo browser afetam o CSS/JS global
 * da página inteira — incluindo elementos da sidebar como o botão "Início".
 *
 * Nota: o forum usa a abordagem CSS (.forum-content) para lidar com
 * cores salvas em modo escuro. Aqui preservamos as cores originais.
 */
export function stripQuillColors(html: string): string {
  // Remove style="" vazios que o Quill pode gerar
  let result = html.replace(/\sstyle=""/gi, '');
  // Remove <style> tags — quando inseridas via innerHTML são aplicadas
  // globalmente pelo browser e podem afetar qualquer elemento da página
  result = result.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
  // Remove <script> tags por segurança (não executados via innerHTML, mas por precaução)
  result = result.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '');
  return result;
}
